module.exports = __webpack_public_path__ + "static/img/login.6ef9859.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login.png
// module id = Uwr+
// module chunks = 1